/**
 * Cookie-consent audit client (RQ78378 / RQ78379).
 *
 * Posts a consent decision to the best-effort server audit log. Goes through
 * ``apiRequest`` so it inherits ``credentials: 'include'`` (affinity) + bearer
 * token + transient retry. The write is idempotent server-side (keyed by
 * ``consent_event_id``), so the shared client's 5xx retry is safe.
 *
 * Failures here are swallowed by the caller — the localStorage consent state is
 * the source of truth for enforcement; the server row is audit only.
 */
import { apiRequest } from './client'
import type { ConsentCategories, Jurisdiction, SourceAction } from '../consent/consentTypes'

export interface ConsentRecordRequest {
  consent_event_id: string
  device_id: string
  categories: ConsentCategories
  jurisdiction: Jurisdiction
  policy_version: string
  source_action: SourceAction
  gpc: boolean
}

export interface ConsentRecordResponse {
  recorded: boolean
}

/** POST /consent — record a consent decision (idempotent, best-effort). */
export async function postConsent(
  body: ConsentRecordRequest
): Promise<ConsentRecordResponse> {
  return apiRequest<ConsentRecordResponse>('/consent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
}
